import type { ShopifyGqlIdType } from "@intelligems/ig-types";

export class ShopifyId {
  public readonly id: string;
  public readonly gid: string;
  public readonly type: ShopifyGqlIdType;

  constructor(options: { type: ShopifyGqlIdType; unknownId: string }) {
    this.type = options.type;
    if (options.unknownId.includes("gid")) {
      this.id = ShopifyId.fromGqlId(options.unknownId);
      this.gid = options.unknownId;
    } else {
      this.id = options.unknownId;
      this.gid = ShopifyId.toGqlId(options.unknownId, options.type);
    }
  }

  public toString() {
    return this.gid;
  }

  static toGqlId(id: string, type: ShopifyGqlIdType): string {
    if (id.includes("gid")) {
      return id;
    }
    return `gid://shopify/${type}/${id}`;
  }

  static fromGqlId(gqlId: string): string {
    // @ts-ignore
    return gqlId.split("/").pop();
  }
}

export class ShopifyMetafieldId extends ShopifyId {
  constructor(unknownId: string) {
    super({ unknownId, type: "Metafield" });
  }

  static toGqlId(id: string): string {
    if (id.includes("gid")) {
      return id;
    }
    return `gid://shopify/Metafield/${id}`;
  }
}
export class ShopifyProductId extends ShopifyId {
  constructor(unknownId: string) {
    super({ unknownId, type: "Product" });
  }

  static toGqlId(id: string): string {
    if (id.includes("gid")) {
      return id;
    }
    return `gid://shopify/Product/${id}`;
  }
}

export class ShopifyVariantId extends ShopifyId {
  constructor(unknownId: string) {
    super({ unknownId, type: "ProductVariant" });
  }

  static toGqlId(id: string): string {
    if (id.includes("gid")) {
      return id;
    }
    return `gid://shopify/ProductVariant/${id}`;
  }
}

export class ShopifyCartTransformId extends ShopifyId {
  constructor(unknownId: string) {
    super({ unknownId, type: "CartTransform" });
  }

  static toGqlId(id: string): string {
    if (id.includes("gid")) {
      return id;
    }
    return `gid://shopify/CartTransform/${id}`;
  }
}

export class ShopifyDiscountAutomaticNodeId extends ShopifyId {
  constructor(unknownId: string) {
    super({ unknownId, type: "DiscountAutomaticNode" });
  }

  static toGqlId(id: string): string {
    if (id.includes("gid")) {
      return id;
    }
    return `gid://shopify/DiscountAutomaticNode/${id}`;
  }
}
